import { createFileRoute } from '@tanstack/react-router';
import { RolesPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/roles')({
  component: RolesRoute,
});

function RolesRoute() {
  const { orgId } = Route.useParams();
  return <RolesPage orgId={orgId} />;
}
